module.exports = __webpack_public_path__ + "img/double-arrow.7082f47a.svg";